<template>
  <div class="mainBox">
    <div class="mainCon">
      <div class="stuMainTitle">
        <span class="title">{{ isPassWordExpired === 1 ? '账户设置：您的密码已过期，请重新设置密码': '账户设置' }}</span>
      </div>
      <div class="content">
        <el-form :model="form" class="formStyle" ref="form" :rules="formRules" :validate-on-rule-change="false">
          <el-form-item label="姓名" prop="realName">
            <el-input v-model="form.realName"></el-input>
          </el-form-item>
          <el-form-item label="证件号">
            <el-input v-model="form.cardNo" disabled></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone" v-if="showInPageList.includes('phone')">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email" v-if="showInPageList.includes('email')">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="password" v-if="this.showInPageList.includes('phone') ||  this.showInPageList.includes('email')">
            <el-input type="password" v-model="form.password" placeholder="请输入密码" auto-complete="new-password"></el-input>
            <ots-password-tooltip></ots-password-tooltip>
          </el-form-item>
          <el-form-item label="确认新密码" prop="confirmPassword" v-if="this.showInPageList.includes('phone') ||  this.showInPageList.includes('email')">
            <el-input type="password" v-model="form.confirmPassword" auto-complete="new-password"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <stu-foot confirmtext="确定" cancelText="" @confirm="updateUser"></stu-foot>
  </div>
</template>
<script>
import { updateInfoFn } from "@/http/modules/student/userConfig";
import { selectUserInfo } from "@/http/modules/student/ticket";
import stuFoot from "../components/stuFoot.vue";
import { checkPwd, checkPhone , checkEmail, passWordStrength} from "@/common/verify.js";
export default {
  components: { stuFoot },
  name: "userConfig",
  data () {
    return {
      tenant : window.localStorage.getItem("tenant"),
      form: {
        realName: "",
        cardNo: "",
        phone: "",
        email: "",
        password: "",
        confirmPassword: "",
        content: "",
      },
      // rules: {
      //   realName: [
      //     { required: true, message: "请填写考点名称", trigger: "blur" },
      //   ],
      //   phone: [
      //     { required: true, message: "请填写手机号", trigger: "blur" },
      //     { validator: checkPhone, trigger: "blur" },
      //   ],
      //   password: [
      //     { required: true, message: "请填写密码", trigger: "blur" },
      //     { validator: passWordStrength, trigger: "blur" },
      //   ],
      //   confirmPassword: [
      //     { required: true, message: "请确认密码", trigger: "blur" },
      //     { validator: this.confirmPassword, trigger: "blur" },
      //   ],
      // },

      isPassWordExpired: 0,
      requiredList: [],
      showInPageList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {
    this.isMustRestPSD();
  },
  computed: {
    formRules() {
      const hasPhone = this.requiredList.includes('phone');
      const hasEmail = this.requiredList.includes('email');
      const requiredPassword = this.showInPageList.includes('phone') ||  this.showInPageList.includes('email');
      let rules = {
        realName: [
          { required: true, message: "请填写考点名称", trigger: "blur" },
        ],
      };

      if (hasPhone) {
        rules.phone = [
          { required: true, message: "请填写手机号", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ];
      }
      if (hasEmail) {
        rules.email = [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { message: "邮箱格式错误", trigger: "blur", type: "email" },
        ];
      }

      if(requiredPassword){
        rules.password = [
          { required: true, message: "请填写密码", trigger: "blur" },
          { validator: passWordStrength, trigger: "blur" },
        ],
        rules.confirmPassword = [
          { required: true, message: "请确认密码", trigger: "blur" },
          { validator: this.confirmPassword, trigger: "blur" },
        ];
      }

      return rules;
    }
  },
  methods: {
    isMustRestPSD(){
      let userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
      this.isPassWordExpired = userInfo.isPassWordExpired;
    },

    confirmPassword(rule, value, callback) {
      if (value) {
        if (this.form.password !== this.form.confirmPassword) {
          callback(new Error("设置密码和确认密码必须相同"))
        } else {
          callback()
        }
      }
      callback()
    },
    async initData() {
      const { data: user } = await selectUserInfo();
      this.form.realName = user.realName;
      this.form.cardNo = user.cardNo;
      this.form.phone = user.phone;
      this.form.email = user.email;
      this.form.id = user.id;

      this.$api.system.getSystemNameFN({ tenant: this.tenant }).then((res) => {
        if(res.code == 1){
          this.requiredList = res.data.baseDefList.filter(item => item.required == 1).map(item => item.fieldName);
          this.showInPageList = res.data.baseDefList.filter(item => item.showInPage == 1).map(item => item.fieldName);
        }else{
          this.$router.push({
            name: "Login",
            query: { tenant: this.tenant },
          });
        }
      });
    },
    validateField(fieldName, validator, errorMsg) {
      return new Promise((resolve, reject) => {
        const value = this.form[fieldName];
        if (!value) {
          resolve();
          return;
        }
        validator({}, value, (error) => {
          if (error) {
            this.$message.error(errorMsg);
            // reject(new Error(errorMsg));
          } else {
            resolve();
          }
        });
      });
    },
    async updateUser() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          // 处理手机号
          if (!this.showInPageList.includes('phone')) {
            this.form.phone = "";
          } else if (!this.requiredList.includes('phone') && this.form.phone) {
            await this.validateField('phone', checkPhone, "手机号格式错误");
          }

          // 处理邮箱
          if (!this.showInPageList.includes('email')) {
            this.form.email = "";
          } else if (!this.requiredList.includes('email') && this.form.email) {
            await this.validateField('email', checkEmail, "邮箱格式错误");
          }

          //如果手机号和邮箱，均不在学生端显示，则清空密码
          if(this.showInPageList.length == 0){
            this.form.password = "";
            this.form.confirmPassword = "";
          }
          const { code } = await updateInfoFn(this.form);
          if (code == 1) {
            this.$message.success("修改成功");
            // 修改密码成功：将控制 ‘是否必须修改密码’ 的 localStorage 值修改为 0
            let userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
            userInfo.isPassWordExpired = 0;
            window.localStorage.setItem("userInfo", JSON.stringify(userInfo));
            this.$router.push({ path: "/stuHome/batch" });
            return;
            // let planId = sessionStorage.getItem("planId");
            // if (planId) {
            //   // 修改密码成功：跳转到首页
            //   this.$router.push({ path: "/stuHome/home" });
            // } else {
            //   this.$router.push({ path: "/stuHome/batch" });
            // }
          }
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.mainBox {
  width: 100%;
  min-width: 700pt;
  background-color: #fff;
}
.mainCon {
  box-sizing: border-box;
  padding: 20px;
  padding-top: 16px;
  width: 100%;
  background: rgba(255, 255, 255, 0.93);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  .content {
    padding-top: 20px;
    display: flex;
    justify-content: center;
    .formStyle {
      width: 360px;
      /deep/ .el-form-item {
        margin-bottom: 22px !important;
      }
      /deep/ .el-input {
        width: 100%;
      }
      /deep/ .el-input .el-input__inner {
        width: 100%;
      }
    }
  }
}
/deep/ .el-table th,
.el-table tr {
  background-color: #ebecff !important;
}

.stuMainTitle {
    font-size: 20px;
    height: 52px;
    line-height: 52px;
    font-weight: bold;
    border-bottom: 1px solid #DADDE6;
}
</style>